import React, { useState } from 'react';
import { get } from 'lodash';
import { object, func, bool } from 'prop-types';
import { Row, Modal } from 'antd';
import { UPDATE_COMERCIAL_POLICY_REFERENCE } from '../../../queries';
import { Text, FlexContainer, ConfirmFooterButtons, IconContainer, Icon } from '../../common';

const ModalDelete = ({ itemToRemove, client, setVisibleModal, visibleModal, refetchQuery }) => {
    const [loading, setLoading] = useState(false);

    const handleRemoveButton = async () => {
        setLoading(true);
        await client.mutate({
            mutation: UPDATE_COMERCIAL_POLICY_REFERENCE,
            variables: {
                comercial_policy: get(itemToRemove, 'comercial_policy'),
                comercial_policy_out: get(itemToRemove, 'comercial_policy')
            }
        });
        setLoading(false);
        setVisibleModal(false);
        refetchQuery();
    };

    return <Modal
        footer={null}
        title={get(itemToRemove, 'title')}
        visible={visibleModal}
        onCancel={() => setVisibleModal(false)}
    >
        <FlexContainer style={{ marginBottom: 70 }} direction='column' align='center'>
            <Row justify='center'>
                <IconContainer color='#ffffff' size={70}>
                    <Icon name='caution' color='#D60000' size={46.8} />
                </IconContainer>
            </Row>
            <Row justify='center'>
                <Text text={'Seguro quiere restaurar el código de ubicación asociado'} />
            </Row>
            <Row>
                <Text centered text='¿Estás seguro?' />
            </Row>
        </FlexContainer>
        <ConfirmFooterButtons
            loading={loading}
            justify='right'
            onCancel={() => setVisibleModal(false)}
            confirmLabel='btn.action.delete'
            onConfirm={handleRemoveButton}
        />
    </Modal>;
};

ModalDelete.propTypes = {
    itemToRemove: object,
    client: object,
    setVisibleModal: func,
    visibleModal: bool,
    refetchQuery: func
};

export default ModalDelete;
